export default "__VITE_ASSET__DU_eIA6V__"